/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PostDeliveryMonitoring from './post-delivery-monitoring';
import PostDeliveryMonitoringDetail from './post-delivery-monitoring-detail';
import PostDeliveryMonitoringUpdate from './post-delivery-monitoring-update';
import PostDeliveryMonitoringDeleteDialog from './post-delivery-monitoring-delete-dialog';

const PostDeliveryMonitoringRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PostDeliveryMonitoring />} />
    <Route path="new" element={<PostDeliveryMonitoringUpdate />} />
    <Route path=":id">
      <Route index element={<PostDeliveryMonitoringDetail />} />
      <Route path="edit" element={<PostDeliveryMonitoringUpdate />} />
      <Route path="delete" element={<PostDeliveryMonitoringDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PostDeliveryMonitoringRoutes;
